import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useCustomContext } from "../_helper/customizer";

export const SelectionListModal = ({
  isOpen,
  toggle,
  title,
  items = [],
  renderItem,
  emptyMessage,
}) => {
  const { layout } = useCustomContext();
  const dir = layout === "rtl" ? "ltr" : "rtl";
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader dir={dir} toggle={toggle}>
        <span className="fw-bold H5">{title}</span>
      </ModalHeader>
      <ModalBody>
        {!hasItems ? (
          <div className="text-center py-5">
            <p className="text-muted">{emptyMessage}</p>
          </div>
        ) : (
          <ul className="list-group">
            {items.map((item, index) => {
              if (renderItem) {
                const node = renderItem(item, index);
                if (React.isValidElement(node) && node.key === null) {
                  return React.cloneElement(node, {
                    key: item?.id ?? index,
                  });
                }
                return node;
              }

              return (
                <li key={item?.id ?? index} className="list-group-item">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      <div className="fw-bold mb-1">
                        {item?.title || item?.label || "-"}
                      </div>
                      {item?.description && (
                        <div className="text-muted">{item.description}</div>
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </ModalBody>
    </Modal>
  );
};

